import React from 'react';
const NotFound = () => {
    return (React.createElement("div", { className: 'not-found' },
        React.createElement("h1", null, "404"),
        React.createElement("h2", null, "PAGE NOT FOUND")));
};
export { NotFound };
